export const Svg_081 = () => (
  <svg style={{ width: '70px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
    <defs>
      <linearGradient
        id="a"
        x1={47.7}
        x2={21}
        y1={14}
        y2={52.1}
        data-name="Gradiente sem nome"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
    </defs>
    <path
      d="M50.3 42.5V41.8s-.1 0-.2-.1c-5.2-2.3-11.2 0-13.6 5.1V39c5.3 2.2 11.4-.4 13.6-5.8.6-1.5.9-3.2.7-4.8V28c0-.2-.2-.3-.4-.4-5.2-2.3-11.2 0-13.6 5.1v-4.9c4.8-3.1 6.2-9.6 3.1-14.4-.9-1.4-2.1-2.5-3.5-3.3h-.9c-5 2.9-6.6 9.3-3.7 14.3.8 1.4 2 2.6 3.3 3.5v4.9c-2.4-5.2-8.6-7.4-13.8-5h-.1l-.1.1s-.2.2-.2.3V28.5c-.5 5.9 3.7 10.9 9.5 11.4 1.6.2 3.3 0 4.8-.7V47c-2.4-5.2-8.6-7.4-13.8-5h-.2l-.1.2v.4c-.5 5.9 3.7 10.9 9.5 11.5 1.6.2 3.3 0 4.8-.7V59h-6.7c-.5 0-1 .4-1 1s.4 1 1 1h15.2c.5 0 1-.4 1-1s-.4-1-1-1h-6.7v-5.6c5.3 2.2 11.4-.4 13.6-5.8.6-1.5.9-3.2.7-4.8Zm-9.9-12.6c2.3-1.6 5.3-2 8-1 .2 4.7-3.5 8.6-8.2 8.8-.7 0-1.5 0-2.2-.2l4.4-3.1c.4-.3.5-.9.2-1.3s-.9-.5-1.3-.2L36.9 36c.3-2.4 1.5-4.6 3.5-6Zm-9.2-11.2c0-2.8 1.4-5.5 3.8-7.1 3.9 2.6 5 7.9 2.4 11.8-.4.6-.9 1.2-1.4 1.6v-5.4c0-.5-.4-.9-1-.9s-1 .4-1 .9V25c-1.8-1.6-2.8-3.9-2.9-6.4Zm-6 17.4c-2.3-1.7-3.6-4.4-3.5-7.2 4.4-1.7 9.3.5 11 4.9.3.7.4 1.4.5 2.1l-4.4-3.1c-.4-.3-1-.2-1.3.2s-.2 1 .2 1.3l4.4 3.1c-2.4.5-4.9 0-6.8-1.4Zm0 14.3c-2.3-1.7-3.6-4.4-3.5-7.2 4.4-1.7 9.3.5 11 4.9.3.7.4 1.4.5 2.1L28.8 47c-.4-.3-1-.2-1.3.2s-.2 1 .2 1.3l4.4 3.2c-2.4.5-4.9 0-6.8-1.4Zm19.6 0c-2 1.4-4.5 1.9-6.8 1.4l4.4-3.2c.4-.3.5-.9.2-1.3s-.9-.5-1.3-.2l-4.4 3.2c.5-4.7 4.7-8.1 9.3-7.6.7 0 1.5.2 2.1.5 0 2.8-1.2 5.6-3.5 7.2Z"
      style={{
        fill: "url(#a)",
      }}
    />
  </svg>
)